// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__Ahwcm","close":"style_close__3aRgK","title":"style_title__CvM-2","text":"style_text__1lbey","bottom_button":"style_bottom_button__wrGBK"};